/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type ModeledAdjustmentActionDtoAction =
  (typeof ModeledAdjustmentActionDtoAction)[keyof typeof ModeledAdjustmentActionDtoAction];

export const ModeledAdjustmentActionDtoAction = {
  RESET: 'RESET',
  SAVE: 'SAVE',
} as const;
